module.exports = __webpack_public_path__ + "img/syringe.abe567ed.svg";